import { useState, useEffect, useRef } from "react";
import { FaLeaf } from "react-icons/fa";
import "../../../assets/css/customer/about/ProcessSections/ProcessSection.css";
import { Container, Row, Col } from "react-bootstrap";

// Local Images
import rice from "../../../assets/images/about/rice.jpg";
import liquidFertilizer from "../../../assets/images/about/liquidFertilizer.jpg";

const progressData = [
  {
    id: 1,
    label: "Direct Farmer-to-Customer Marketplace",
    percentage: 100,
  },
  {
    id: 2,
    label: "Secure Ordering & Payment System",
    percentage: 100,
  },
  {
    id: 3,
    label: "Good products for customers",
    percentage: 100,
  },
];

const ProcessSection = () => {
  const [progressVisible, setProgressVisible] = useState(false);
  const progressRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (hasAnimated.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setProgressVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    if (progressRef.current) {
      observer.observe(progressRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="process-section">
      <Container className="process-container">
        <Row className="align-items-center">
          {/* Left Side: Images */}
          <Col xs={12} lg={6} className="mb-5 mb-lg-0">
            <div className="process-images">
              <div className="image-large">
                <img src={rice} alt="Agricultural Marketplace" />
              </div>

              <div className="image-small">
                <img src={liquidFertilizer} alt="Fertilizers" />
              </div>

              <div className="dots-pattern"></div>
            </div>
          </Col>

          {/* Right Side: Content */}
          <Col xs={12} lg={6}>
            <div className="process-content">
              <h2>How KisaanMart Works</h2>

              <div className="process-info">
                <div className="Pinfo-icon">
                  <FaLeaf />
                </div>

                <p>
                  KisaanMart connects farmers, store owners, customers, and
                  deliverymen through one digital agricultural marketplace.
                  Users can buy and sell agricultural products, manage orders,
                  and complete deliveries through the platform.
                </p>
              </div>

              {/* Progress Bars */}
              <div className="progress-bars" ref={progressRef}>
                {progressData.map((progress, index) => (
                  <div
                    key={progress.id}
                    className="progress-item"
                    style={{
                      animationDelay: `${index * 0.2}s`,
                    }}
                  >
                    <div className="progress-header">
                      <span>{progress.label}</span>
                    </div>

                    <div className="progress-bar">
                      <div
                        className={`progress-fill ${
                          progressVisible ? "progress-animated" : ""
                        }`}
                        style={{
                          width: progressVisible
                            ? `${progress.percentage}%`
                            : "0%",
                          transitionDelay: `${index * 0.2}s`,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>

              <p className="process-description">
                The platform provides a simple digital process for product
                discovery, ordering, payment, delivery, and customer support.
                KisaanMart helps make agricultural trading more convenient and
                accessible for all users.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProcessSection;
